<template>
  <div class="storeActionListDiv">
    <van-tabs
      v-model="lineListActive"
      v-if="lineList.length > 1"
      sticky
      @change="changeTab"
    >
      <van-tab :title="item.name" v-for="item in lineList" :key="item.id">
      </van-tab>
    </van-tabs>
    <!-- 排队中 -->
    <div class="cont2" :style="'height:' + cont2Height + ';'">
      <p class="queuingListTitle" v-if="queuingList.length > 0">正在排队中：</p>
      <div
        class="cont2-left defaultBg"
        v-for="(item, index) in queuingList"
        :key="index"
      >
        <div class="cont2-left-blk">
          <div class="top">{{ item.code }}</div>
          <div class="image">
            <!-- 不同车的类型不一致 车辆类型（1平板车；2货柜车；3槽罐车；4其他；5高栏车）-->
            <!-- 平板车 -->
            <img
              src="../assets/img/flat.png"
              alt=""
              width="70px"
              v-if="item.report_info.vehicle_type === 1"
            />
            <!-- 货柜车 -->
            <img
              src="../assets/img/truck.png"
              alt=""
              width="70px"
              v-else-if="item.report_info.vehicle_type === 2"
            />
            <!-- 高栏车 -->
            <img
              src="../assets/img/gaolan.png"
              alt=""
              width="70px"
              v-else-if="item.report_info.vehicle_type === 5"
            />
            <img src="../assets/img/else_icon.png" v-else alt="" width="70px" />
          </div>
          <div v-if="item.work_state == 2" class="bottom">正在作业中</div>
        </div>
        <div class="cont2-right">
          <span class="right1">{{ item.report_info.license_plate }}</span>
          <span class="right2"
            >车型：{{ vehicleTypeText(item.report_info.vehicle_type) }}</span
          ><br />
          <!-- 单位：{{ item.report_info.unit }}<br /> -->
          <span class="right3"
            >进厂时间：{{ formatTime(item.into_factory_time) }}</span
          >
          <br />
          <span
            v-if="formatStatus(item.into_factory_time, item.booking_time) == 0"
            class="colorBlueLight"
            >提前到厂</span
          >
          <span
            v-if="formatStatus(item.into_factory_time, item.booking_time) == 1"
            class="colorGreenDark"
            >准时到场</span
          >
          <span
            v-if="formatStatus(item.into_factory_time, item.booking_time) == 2"
            class="colorPink"
            >迟到到厂</span
          >
          <br />
          <span class="">已等待：{{ timeCacl(item.create_time) }}</span>
          <img
            v-if="
              privilegeConfig.keys &&
                privilegeConfig.keys.indexOf('c-car-queue-order-mgr') >= 0
            "
            @click="
              showActionObjItem = item;
              showActionList = true;
            "
            class="acImg"
            src="../assets/img/px.png"
            alt=""
          />
        </div>
      </div>
      <div v-if="queuingList.length == 0" class="emptyData">
        <Empty></Empty>
      </div>
    </div>

    <!-- 弹窗 -->
    <van-dialog
      v-model="dialogShow"
      show-cancel-button
      :showConfirmButton="false"
      :showCancelButton="false"
    >
      <template #default>
        <div class="dialog-blk">
          <div v-if="showActionSelectTag === 'moveTop'">
            <span>“</span>
            <span class="colorPink">
              {{ showActionObjItem.report_info.license_plate }}
            </span>
            <span>”当前处于 </span>
            <span class="colorPink">第 {{ showActionObjItem.nowIndex }}位</span>
            <span>，确定要</span>
            <span class="colorPink">置顶到第一位</span>
            <span>吗？</span>
          </div>
          <div v-if="showActionSelectTag === 'moveOne'">
            <span>“</span>
            <span class="colorPink">
              {{ showActionObjItem.report_info.license_plate }}
            </span>
            <span>”当前处于 </span>
            <span class="colorPink">第 {{ showActionObjItem.nowIndex }}位</span>
            <span>，确定要</span>
            <span class="colorPink">要上移一位</span>
            <span>吗？</span>
          </div>
          <div v-if="showActionSelectTag === 'moveBottom'">
            <span>“</span>
            <span class="colorPink">
              {{ showActionObjItem.report_info.license_plate }}
            </span>
            <span>”当前处于 </span>
            <span class="colorPink">第 {{ showActionObjItem.nowIndex }}位</span>
            <span>，确定要</span>
            <span class="colorPink">移到最后一位</span>
            <span>吗？</span>
          </div>
          <div v-if="showActionSelectTag === 'stop'">
            <span>确定要终止“</span>
            <span class="colorPink">
              {{ showActionObjItem.report_info.license_plate }}
            </span>
            <span>”的排队吗？这将从排队队列中移除车辆，车辆将无法被叫号！</span>
          </div>
        </div>
        <div style="display: flex;">
          <div style="flex: 1;" @click="dialogShow = false">
            <van-button block class="dialogBtnCancel">取消</van-button>
          </div>
          <div style="flex: 1;" @click="onConfirm">
            <van-button block class="dialogBtnConfirm">确认</van-button>
          </div>
        </div>
      </template>
      <template #title>
        <div style="font-size: 15px;">确认提示</div>
      </template>
    </van-dialog>
    <mbComSelect></mbComSelect>

    <!-- 排序调整操作 -->
    <van-dialog
      v-model="showActionList"
      :show-cancel-button="false"
      :show-confirm-button="false"
      class="showActionListDialog"
    >
      <template #title>
        <div style="font-size: 15px;">排序调整</div>
      </template>
      <template #default>
        <p class="p1">
          <span>正在对</span>
          <span class="s1">{{ showActionObjItem.code }} </span>
          <span>“ </span>
          <span class="colorPink"
            >{{ showActionObjItem.report_info.license_plate }}
          </span>
          <span>” 进行排序 </span>
          <br />
          <span>调整操作：</span>
        </p>
        <p>
          <van-button @click="moveUp('moveTop')" type="primary"
            >置顶</van-button
          >
        </p>
        <p>
          <van-button @click="moveUp('moveOne')" type="primary"
            >上移一位</van-button
          >
        </p>
        <p>
          <van-button @click="moveUp('moveBottom')" type="primary"
            >移到最后</van-button
          >
        </p>
        <p>
          <van-button @click="moveUp('stop')" type="danger">终止</van-button>
        </p>
        <p>
          <van-button type="info" @click="showActionList = false"
            >取消</van-button
          >
        </p>
      </template>
    </van-dialog>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { Toast } from "vant";
import moment from "moment";
import socketListStoreMixin from "@/mixins/rh/socketListStoreMixin.js";
import socketListComputedMixin from "@/mixins/rh/socketListComputedMixin.js";
import socketConnetMixin from "@/mixins/rh/socketConnetMixin.js";
import Empty from "@/components/tips/Empty.vue";
import mbComSelect from "@/components/mbComSelect/index.vue";
import privilegeMixin from "@/mixins/rh/privilegeMixin.js";

export default {
  props: {},
  data() {
    return {
      socketConnetMixinRoom: "ROOM_QUEUE",
      isActive: "",
      dialogShow: false,
      dialogType: "",
      rejectReason: "", // 拒绝理由
      actionQueueId: "",
      actionQueueObj: "",
      isWarehouseman: false, // 是否班长
      queuingList: [], // 排队中
      callingList: [], // 叫号中
      callingPassList: [], // 叫号中-过号
      loadingList: [], // 装货中
      loadingRejectList: [], // 装货中-拒绝装货
      loadingEndList: [], // 装货中-结束
      lineList: [], // 产品线
      lineListActive: 0, // 当前选中的产品线
      calculationTime: null,
      calculationTimeInterval: null,
      showActionObjItem: {
        code: "",
        report_info: {}
      },
      showActionList: false,
      showActionSelectTag: ""
    };
  },
  beforeRouteLeave(_to, _form, next) {
    try {
      this.$common.mbToastClose();
      window.clearInterval(this.calculationTimeInterval);
    } catch (error) {
      console.error(error);
    }
    next();
  },
  mixins: [
    socketConnetMixin,
    socketListStoreMixin,
    socketListComputedMixin,
    privilegeMixin
  ],
  watch: {
    async isJoinRoomAndMonitorEven(val) {
      if (val) {
        console.log("清空数据");
        console.log("获取业务数据");
        this.$common.mbToastLoading();
        let proLines = await this.getProLines();
        this.lineList = proLines.data.data;
        let permission = await this.getPermission();
        this.$common.mbToastClose();
        permission = permission.data.data;
        // console.log(permission);
        // 班长显示排队中的业务线
        if (permission.keys.indexOf("c-car-qeue-ww-leave-call") > 0) {
          this.isWarehouseman = true;
          this.isActive = "queuing";
        } else {
          this.isWarehouseman = false;
          this.isActive = "calling";
        }
        this.getListData();
      } else {
        console.log("socket断开");
      }
    },
    evenQueueList(val) {
      console.warn("socket数据来", evenQueue);
      const evenQueue = JSON.parse(val);
      this.changeAllList(evenQueue);
    }
  },
  components: {
    mbComSelect,
    Empty
  },
  computed: {
    cont2Height() {
      if (this.lineList.length > 1) {
        return "calc(100% - 45px)";
      } else {
        return "100%";
      }
    }
  },
  async mounted() {
    this.fetchPrivilege();
  },
  methods: {
    ...mapActions(["fetchPrivilege"]),
    // 切换按钮
    changeBtn(tag) {
      this.isActive = tag;
    },

    // 操作dialog
    handle(tag, item) {
      this.dialogShow = true;
      this.dialogType = tag;
      this.actionQueueId = item.id;
      this.actionQueueObj = item;
    },

    // 确认
    async onConfirm() {
      let tag = this.showActionSelectTag;
      let queue_id = this.showActionObjItem.id;
      if (tag === "moveOne") {
        await this.$common.http({
          url: "/api/queue/warehouseman/move_up_queue",
          data: {
            queue_id
          }
        });
      } else if (tag === "moveTop") {
        await this.$common.http({
          url: "/api/queue/warehouseman/set_top_queue",
          data: {
            queue_id
          }
        });
      } else if (tag === "moveBottom") {
        await this.$common.http({
          url: "/api/queue/warehouseman/set_bottom_queue",
          data: {
            queue_id
          }
        });
      } else if (tag === "stop") {
        await this.$common.http({
          url: "/api/queue/warehouseman/remove_queue",
          data: {
            queue_id
          }
        });
      }
      this.dialogShow = false;
      Toast.success("操作成功");
    },

    // 取消
    onCancel() {
      this.dialogShow = false;
    },
    // 获取权限
    getPermission() {
      return this.$common.http({
        method: "get",
        url: "/api/permission/list_mine",
        noLoading: true
      });
    },
    // 获取产品线
    getProLines() {
      return this.$common.http({
        method: "get",
        url: "/api/queue/warehouseman/query_business",
        noLoading: true
      });
    },
    // h获取排队中的数据
    getWarehousemanList() {
      this.$common
        .http({
          url: "/api/queue/warehouseman/query_loading_queue",
          data: {
            business_id:
              this.lineList.length > 0
                ? this.lineList[this.lineListActive].id
                : ""
          }
        })
        .then(res => {
          this.queuingList = [];
          this.queuingList = res.data.data;
          // this.queuingList = [{}, {}, {}, {}, {}, {}, {}, {}];
        });
    },
    // h获取查看叫号中，装货中队列
    getWcommonList(state) {
      this.$common
        .http({
          url: "/api/queue/warehouseman/query_queue",
          data: {
            state,
            business_id:
              this.lineList.length > 0
                ? this.lineList[this.lineListActive].id
                : ""
          }
        })
        .then(res => {
          const list = res.data.data;
          if (state == 1) {
            this.callingList = [];
            this.callingPassList = [];
            list.forEach(element => {
              if (element.queue_state == 2) {
                this.callingList.push(element);
              }
              if (element.queue_state == 3) {
                this.callingPassList.push(element);
              }
            });
            // this.callingList = [{}, {}, {}, {}, {}, {}, {}, {}];
            // this.callingPassList = [{}, {}, {}, {}, {}, {}, {}, {}];
          }
          if (state == 2) {
            this.loadingList = [];
            this.loadingEndList = [];
            list.forEach(element => {
              if (
                element.loading_state == 1 ||
                element.loading_state == 3 ||
                element.loading_state == 4
              ) {
                this.loadingList.push(element);
              }
              if (element.loading_state == 2) {
                this.loadingRejectList.push(element);
              }
              if (element.loading_state == 5 || element.loading_state == 6) {
                this.loadingEndList.push(element);
              }
            });
            // this.loadingList = [{}, {}, {}, {}, {}, {}, {}, {}];
            // this.loadingEndList = [{}, {}, {}, {}, {}, {}, {}, {}];
          }
        });
    },
    // 切换产品线
    changeTab(index) {
      console.log(index);
      this.getListData();
    },
    // 获取列表数据
    getListData() {
      // this.queuingList = [];
      // this.callingList = [];
      // this.callingPassList = [];
      // this.loadingList = [];
      // this.loadingEndList = [];
      this.getWarehousemanList();
      // this.getWcommonList(1);
      // this.getWcommonList(2);
    },
    changeAllList({ actions, data }) {
      actions.forEach(element => {
        console.log(element, data);
        // 产品线过滤
        console.log(
          "激活产品线id:" + this.lineList[this.lineListActive].id,
          "变更数据id：" + data.business_id
        );
        if (data.business_id != this.lineList[this.lineListActive].id) {
          return;
        }
        // 排队中
        if (element.queue == "QUEUE_QUEUE") {
          console.log(
            this.queuingList[0].report_info.license_plate,
            this.queuingList
          );
          let tmpQueuingList = JSON.parse(JSON.stringify(this.queuingList));
          this.queuingList = this.reSetListBySocket(
            element.action,
            data,
            tmpQueuingList
          );
          console.log(
            this.queuingList[0].report_info.license_plate,
            this.queuingList
          );
        }
        // 叫号中-正在叫号
        if (element.queue == "QUEUE_CALLING") {
          let tmpCallingList = JSON.parse(JSON.stringify(this.callingList));
          this.callingList = this.reSetListBySocket(
            element.action,
            data,
            tmpCallingList
          );
        }
        // 叫号中-已过号
        if (element.queue == "QUEUE_PASS_CALL") {
          let tmpCallingPassList = JSON.parse(
            JSON.stringify(this.callingPassList)
          );
          this.callingPassList = this.reSetListBySocket(
            element.action,
            data,
            tmpCallingPassList
          );
        }
        // 队列-装车中
        if (element.queue == "QUEUE_LOADING") {
          let tmpLoadingList = JSON.parse(JSON.stringify(this.loadingList));
          this.loadingList = this.reSetListBySocket(
            element.action,
            data,
            tmpLoadingList
          );
        }
        // 队列-完成
        if (element.queue == "QUEUE_FINISH") {
          let tmpLoadingEndList = JSON.parse(
            JSON.stringify(this.loadingEndList)
          );
          this.loadingEndList = this.reSetListBySocket(
            element.action,
            data,
            tmpLoadingEndList
          );
        }
        // 队列-拒绝
        if (element.queue == "QUEUE_REFUSED_LOADING") {
          let tmploadingRejectList = JSON.parse(
            JSON.stringify(this.loadingRejectList)
          );
          this.loadingRejectList = this.reSetListBySocket(
            element.action,
            data,
            tmploadingRejectList
          );
        }
      });
    },
    // 叫号
    intoCallingPage() {
      this.$router.push({
        path: "/rhwxStoreCalling",
        query: {
          business_id: this.lineList[this.lineListActive].id
        }
      });
    },
    moveUp(tag) {
      console.log(tag);
      this.showActionSelectTag = tag;
      let queue_id = this.showActionObjItem.id;
      this.$common
        .http({
          url: "/api/queue/warehouseman/get_queue_ranking",
          data: {
            queue_id
          }
        })
        .then(res => {
          let index = res.data.data;
          this.showActionList = false;
          this.dialogShow = true;
          this.showActionObjItem.nowIndex = index;
        });
    }
  },
  created() {
    // window.setInterval(() => {
    //   this.$common.http({
    //     url: "/api/login_test/ws_test",
    //     data: {
    //       even: "EVENT_QUEUE_REGAIN_RANK",
    //       queue_id: "73c773b78f6a4f17bdd73ffb766df671"
    //     },
    //     noLoading: true
    //   });
    // }, 10000);
    this.calculationTime = moment();
    this.calculationTimeInterval = window.setInterval(() => {
      this.calculationTime = moment();
    }, 60000);
    this.$common.mbToastLoading();
  }
};
</script>
<style lang="less" scoped>
@import "../assets/css/common";
.storeActionListDiv {
  height: 100vh;
  box-sizing: border-box;
  border-top: 1px solid #fff;
  background: #f4f5f6;
  overflow: hidden;
  .cont1 {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 16px;
    background: #fff;
    margin: -1px 0px 0px;
    position: fixed;
    width: calc(100vw - 32px);
    z-index: 999;
    .blk {
      border: 1px solid #008b5e;
      display: inline-block;
      font-size: 16px;
      padding: 8px 12px;
      border-radius: 3px;
    }
    &-blk1 {
      background: #008b5e;
      color: #fff;
    }
    &-blk2 {
      color: #008b5e;
    }
  }
  .queuingListTitle {
    margin: 0;
    padding-bottom: 16px;
    font-size: 18px;
  }
  // 排队中
  .cont2 {
    background: #fff;
    padding: 16px;
    box-sizing: border-box;
    overflow: auto;
    &-left {
      background: #f9f9fa;
      margin-bottom: 10px;
      display: flex;
      &-blk {
        display: inline-block;
        margin-right: 10px;
        width: 108px;
        // text-align: center;
        vertical-align: top;
        position: relative;
        .top {
          background: #00c8d2;
          box-shadow: 0 2px 4px 0 rgba(0, 200, 210, 0.1);
          border-radius: 4px 0 13px 0;
          // width: 55px;
          text-align: center;
          color: white;
          line-height: 23px;
          margin-bottom: 10px;
          font-size: 18px;
          min-width: 35px;
          display: inline-block;
          padding: 2px 11px;
        }
        .image {
          top: 54%;
          left: 50%;
          position: absolute;
          transform: translate(-50%, -50%);
        }
        .bottom {
          font-size: 14px;
          box-shadow: 0 2px 4px 0 rgba(0, 200, 210, 0.1);
          width: 81px;
          color: white;
          line-height: 23px;
          background: #ec3f67;
          border-radius: 0 11px 0 4px;
          position: absolute;
          text-align: center;
          bottom: 0px;
        }
      }
    }
    &-right {
      display: inline-block;
      font-size: 14px;
      line-height: 22px;
      padding: 12px 0px;
      // width: calc(88vw - 120px);
      width: calc(100% - 118px);
      color: #4f4a4c;
      position: relative;
      .right1 {
        line-height: 26px;
        font-size: 18px;
        color: #000;
      }
      .right2 {
        display: inline-block;
        position: relative;
        bottom: 2px;
        left: 10px;
      }
      .right3 {
        display: inline-block;
        position: relative;
        width: calc(100% - 40px);
      }
      .right5 {
        float: right;
      }
      .acImg {
        position: absolute;
        right: 5px;
        width: 35px;
        top: calc(50% - 18px);
      }
    }
  }
  .font16 {
    font-size: 16px;
  }
  // 叫号中
  .cont3 {
    background: #fff;
    padding: 16px;
    margin: 10px 0px 10px;
    &-title {
      font-size: 18px;
      padding-bottom: 14px;
    }
    &-left {
      font-size: 14px;
      line-height: 22px;
      padding: 0px 0px 7px;
      flex: 2;
      color: #4f4a4c;
      .top {
        background: #00c8d2;
        box-shadow: 0 2px 4px 0 rgba(0, 200, 210, 0.1);
        border-radius: 4px 0 13px 0;
        width: 55px;
        text-align: center;
        color: white;
        font-size: 18px;
        margin-bottom: 5px;
      }
      .left1 {
        line-height: 26px;
        font-size: 18px;
        color: #000;
      }
      .left2 {
        float: right;
        margin-top: 2px;
      }
      .left5 {
        float: right;
      }
    }
    &-right {
      flex: 1;
      display: flex;
      align-items: center;
      flex-direction: column;
      flex-flow: wrap;
      padding: 21px 0px;
      & > div {
        flex: 1;
        text-align: right;
      }
    }
  }
  .defaultBg {
    background-image: linear-gradient(270deg, #fff, #f8f8f8, #f4f5f6);
  }
  .pinkBg {
    background-image: linear-gradient(270deg, #fff, #fdebef);
  }
  .greyBg {
    background: #cacaca !important;
  }
  .mgBottom10 {
    margin-bottom: 10px;
  }
  .btn {
    height: 30px !important;
    width: 81px !important;
    padding: 0px !important;
    font-size: 16px !important;
  }
  .van-dialog__message {
    font-size: 16px;
  }
  .van-dialog__header {
    opacity: 0.9;
    font-size: 16px;
    color: #000000;
    text-align: center;
  }
  .emptyData {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .showActionListDialog {
    p {
      margin: 10px 0;
      padding: 0 16px;
      font-size: 17px;
      color: #666;
      .s1 {
        color: #333;
        font-size: 16px;
      }
      button {
        width: 100%;
        font-size: 16px;
      }
      .van-button--danger {
        background-color: #00cece;
        border: 1px solid #00cece;
      }
      .van-button--info {
        margin-top: 20px;
        background-color: rgba(0, 0, 0, 0.2);
        border: 1px solid rgba(0, 0, 0, 0.2);
      }
    }
  }
}
</style>
<style lang="less">
.showActionListDialog {
  .van-dialog__header {
    font-size: 19px;
    color: #000;
  }
}
</style>
